export default {
  downtimeUrl: "https://pl3.kodland.tech",
  startPage: {
    title: "Zdobądź zaproszenie na BEZPŁATNĄ lekcję programowania lub tworzenia gier",
    subtitle:
      "Twoje dziecko stworzy swój pierwszy projekt: grę albo program! Produktywnie spędzi czas przy komputerze👍",
    button: "Zaczynajmy 😎",
    gift: 10
  },
  successPage: {
    title: "Wybierz datę i godzinę, aby otrzymać lekcję ZA DARMO",
    subtitle: "Kliknij przycisk “📆 Zarezerwować lekcję“, aby dokończyć rejestrację",
    button: "📆 Zarezerwować lekcję",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Dziękujemy za zaufanie do naszej platformy edukacyjnej! Niestety, tablety czy telefony nie nadają się na lekcje. Czekamy na Państwo na zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Czy chcesz, żeby czas spędzany przez Twoje dziecko przy komputerze był bardziej produktywny?",
      answers: [
        "😍 Tak!",
        "🤔 Nie. To tylko zabawa i jest w porządku",
      ],
    },
    2: {
      question: "Chcesz, aby Twoje dziecko zdobyło wysoko poszukiwany zawód?",
      answers: [
        "👍 Tak!",
        "⚡️ Nie",
      ],
    },
    3: {
      question: "Czy masz komputer/laptop służący do nauki?",
      answers: [
        "👍 Tak",
        {
          answer: "😕 Nie",
          stopAnswer: true
        },
      ],
    },
  },
};
